<!--公示信息-->
<template>
  <div>
    <div class="content" id="pubilcyInfo">
      <div class="news">
        <div class="locate">
          <p>当前位置 > 公示信息 > 轮候信息</p>
        </div>
        <el-divider></el-divider>
        <div class="detail">
          <p class="title">
            上海市嘉定区公共租赁住房轮候信息
          </p>
          <div class="mainInfo1">
              （数据统计截止日期：{{ date }}）
          </div>
          <div class="list">
              <el-table :data="list" border style="width: 100%" :span-method="arraySpanMethod">
                  <el-table-column prop="streetTown" label="街道" width="200" align="center">
                  </el-table-column>
                  <el-table-column prop="communityName" label="项目名称" width="250" align="center">
                  </el-table-column>
                  <el-table-column prop="communityAddress" label="项目地址" width="200" align="center">
                  </el-table-column>
                  <el-table-column prop="roomKindName" label="户型" align="center">
                  </el-table-column>
                  <el-table-column prop="roomNum" label="房源总套数" align="center">
                  </el-table-column>
                  <el-table-column prop="waitingNum" label="轮候人数" align="center">
                  </el-table-column>
              </el-table>
          </div>
          <div class="mainInfo2">
              备注：上述轮候信息每天更新一次，如需查询实时轮候信息请在“网站首页-候租人数查询”中查询。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PortalApi from "@/api/portal/index";
export default {
  data() {
    return {
      date: '',
      list: []
    };
  },
  methods: {
    getData() {
      PortalApi.getPublicyWaitingInfo()
        .then(
          (res) => {
            this.date = res.data.date;
            this.list = res.data.list;
          },
          (err) => {
            this.$message({
              message: err,
              center: true,
            });
          }
        )
        .catch((error) => {
          this.$message({
            message: error,
            center: true,
          });
        });
    },
    indexMethod(index){
      return index;
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }){
      console.log(column + rowIndex);
      if(columnIndex == 0){
        return [row.colspanStreet,1]
      }
      else if(columnIndex == 1 || columnIndex == 2){
        return [row.colspanCommunity, 1]
      }
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="less" scoped>
#pubilcyInfo {
  .news {
    width: 1176px;
    height: auto;
    margin: 41px auto;
    display: block;
  }

  .news .locate {
    padding-top: 27px;
    width: 270px;
    height: 15px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    text-align: left;
  }

  .detail {
    margin-top: 46px;
    text-align: center;
  }

  .title {
    height: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2c2c2c;
    line-height: 48px;
  }

  .mainInfo1 {
    text-align: center;
    margin: 20px 0px;
    font-size: 16px;
    font-weight: 400;
    color: #343434;
    line-height: 48px;
    text-indent:2em;
  }

  .mainInfo2 {
    text-align: left;
    text-indent:0;
    font-size: 16px;
    margin-top: 10px;
  }
}
</style>